import Button from '@ui/Button';
import React, { useRef, useState, useEffect } from 'react';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Typography from '@ui/Typography';
import { isEmpty, sortBy, trim } from 'lodash-es';
import useStore from '../../../stores/store';
import { ToggleButton } from '@ui/ToggleButton';

const schema = yup.object().shape({
  // skills: yup
  //   .string()
  //   .required('Please provide a brief message about yourself')
  //   .min(10, 'Message must be at least 10 characters')
  //   .max(1000, 'Message must be at most 1000 characters'),
});

function NonProfitOnBoardFormFinalStep(props) {
  const { onSubmit, onBack } = props;

  const [skills, setSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState({});
  const userProfile = useStore((state) => state.user.profile);

  const form = useForm({
    defaultValues: {
      skills: '',
    },
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = form;

  const updateSelectedSkills = (selected) => {
    setSelectedSkills(selected);
  };

  // fetch all skills
  useEffect(() => {
    const fetchSkills = async () => {
      const { data: skillData } = {
        data: [
          {
            id: 1,
            skill_title: 'Accounting',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 2,
            skill_title: 'Branding',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 3,
            skill_title: 'Business Development',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 4,
            skill_title: 'Communication',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 5,
            skill_title: 'Copy',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 6,
            skill_title: 'Data Analysis',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 7,
            skill_title: 'Database Admin',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 8,
            skill_title: 'Design',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 9,
            skill_title: 'Development',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 10,
            skill_title: 'Digital Advertising & Marketing',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 11,
            skill_title: 'Engineering',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 12,
            skill_title: 'Entrepreneurship',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 13,
            skill_title: 'Event Planning',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 14,
            skill_title: 'Executive Leadership',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 15,
            skill_title: 'Finance',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 16,
            skill_title: 'Fundraising',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 17,
            skill_title: 'Grant Writing',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 18,
            skill_title: 'Graphic Design',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 19,
            skill_title: 'Human Resource',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 20,
            skill_title: 'Information Technology',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 21,
            skill_title: 'Legal',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 22,
            skill_title: 'Management',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 23,
            skill_title: 'Marketing',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 24,
            skill_title: 'Organizational Design',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 25,
            skill_title: 'Photography & Video',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 26,
            skill_title: 'Project Management',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 27,
            skill_title: 'Public Relations',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 28,
            skill_title: 'Research',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 29,
            skill_title: 'Sales',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 30,
            skill_title: 'Search Engine Marketing & Optimization',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 31,
            skill_title: 'Social Media',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 32,
            skill_title: 'Strategy Consulting',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 33,
            skill_title: 'Talent Recruitment',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 34,
            skill_title: 'Training',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 35,
            skill_title: 'Web Design',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
          {
            id: 36,
            skill_title: 'Web Development',
            description: '',
            icon: null,
            createdAt: '2022-08-01T04:10:26.445Z',
            updatedAt: '2022-08-01T04:10:26.445Z',
          },
        ],
      };

      setSkills(sortBy(skillData, 'skill_title'));
    };
    fetchSkills();
  }, []);

  useEffect(() => {
    if (userProfile) {
      const userSkills = {};
      userProfile.skills.forEach((skill) => {
        const item = skills.find((s) => s.id === skill.id);
        if (item) {
          userSkills[item.id] = item;
        }
      });
      updateSelectedSkills(userSkills);
    }
  }, [userProfile, skills]);

  const handleSkillChange = (skills) => {
    setSelectedSkills(skills);
  };

  const getUpdatedSelectedList = (selectedList, item, isSelected) => {
    const newSelectedList = { ...selectedList };
    if (isSelected) {
      newSelectedList[item.id] = item;
    } else {
      delete newSelectedList[item.id];
    }
    return newSelectedList;
  };

  const handleSkillSelection = (skill, isSelected) => {
    const selected = getUpdatedSelectedList(selectedSkills, skill, isSelected);
    updateSelectedSkills(selected);
  };

  const handleFormSubmit = async (data) => {
    // if (!isEmpty(selectedSkills)) {
    //   const { data, errored } = await requestPut('/users/skills/me', {
    //     skills: selectedSkills.map((cause) => cause.id),
    //   });
    //   if (!errored) {
    //     console.log('Skills---->', data);
    //   }
    // }
    onSubmit(data);
  };

  return (
    <div className="flex flex-col gap-8 flex-1 w-full">
      <div className="lg:flex flex-col divide-y gap-6 w-full">
        <div>
          <Typography variant="dialogtitle" className="flex justify-center">
            Skills you want to Support
          </Typography>
        </div>

        <div></div>
      </div>

      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="flex flex-col gap-1.5 divide-y">
        <div className="grid gap-8 overflow-y-auto h-72">
          <div className="flex flex-wrap gap-4">
            {skills.map((skill) => (
              <div>
                <ToggleButton
                  key={skill.id}
                  label={skill.skill_title}
                  checked={!!selectedSkills[skill.id]}
                  onToggle={(status) => handleSkillSelection(skill, status)}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="grid gap-16">
          <div></div>

          <div className="flex justify-between flex-rows gap-4">
            <div className="flex-flow-col">
              <Button
                variant="outlined"
                color="primary"
                className="mt-2"
                onClick={onBack}>
                Back
              </Button>
            </div>

            <div className="flex-flow-col">
              <Button
                variant="filled"
                color="primary"
                type="submit"
                className="mt-2">
                Apply
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default NonProfitOnBoardFormFinalStep;
